import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, MAX_FILE_SIZE_KB } from "./constants";

const iniState = {
  sessionId: null,
  loading: true,
  refreshing: true,
  expanded: false,
  viaPortal: false,
  accentColor: null,
  content: [],
  combinedContent: [],
  showEditTypeModal: false,
  isSaveBtnDisabled: true,
  settings: {
    content_due_date: null,
    content_due_date_formatted: null,
    content_filetypes: [],
    content_limit: 3,
    enable_content_upload: true,
    enable_comments: true,
    min_size: 0,
    max_size: MAX_FILE_SIZE_KB,
    size_type: "kb",
    set_limit_size: false,
    bizzabo_integration_enabled: false
  },
  //
  fileUploadUploadedUrls: [],
  fileUploadData: [],
  fileUploadProgress: {},
  fileUploadFiles: {},
  fileUploadUploadHasFinished: false,
  fileUploadUrl: "",
  fileUploadUrls: [],
  fileUploadUrlMessage: "",
  fileUploadIsValidUrl: false
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    refreshContent: R.identity,
    sendComment: R.identity,
    downloadFile: R.identity,
    saveUpdatedType: R.identity,
    deleteFile: R.identity,
    deleteAllVersions: R.identity,
    setInitialData: (_, { payload: { settings, content, accentColor } }) => ({
      accentColor,
      settings,
      content,
      combinedContent: R.reduce((a, b) => {
        return [...a, b, ...b.versions];
      }, [])(content)
    }),
    setContent: (_, { payload: content }) => ({
      content,
      combinedContent: R.reduce((a, b) => {
        return [...a, b, ...b.versions];
      }, [])(content)
    }),
    //
    initFileDropzone: R.identity,
    fileUploadRemoveUploadedUrls: R.identity,
    onFileUploadProgress: R.identity,
    onFileUploadCancel: R.identity,
    onFileUploadFailed: R.identity,
    onFileUploadFinished: R.identity,
    updateFileUploadFileData: R.identity,
    validateFileUploadUrl: R.identity,
    addFileUploadUrl: R.identity,
    cancelFileUploadUrl: R.identity,
    saveFileUpload: R.identity,
    cancelFileUpload: R.identity,
    showEditDocumentPage: R.identity,
    cleanFileUploadState: () => ({
      fileUploadUploadedUrls: [],
      fileUploadData: [],
      fileUploadProgress: {},
      fileUploadFiles: {},
      fileUploadUploadHasFinished: false,
      fileUploadUrl: "",
      fileUploadUrls: [],
      fileUploadUrlMessage: "",
      fileUploadIsValidUrl: false
    }),
    setFileUploadInitialData: (_, { payload: { fileUploadData = [] } }) => ({
      fileUploadData
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
